// src/components/Magazine/Maddalena.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import '../../styles/magazineGallery.scss';

function Maddalena() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/Maddalena/Maddalena_1.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/Maddalena/Maddalena_2.jpg',
        },
        {
            id: 3,
            imgSrc: '/images/Maddalena/Maddalena_3.jpg',
        },
        {
            id: 4,
            imgSrc: '/images/Maddalena/Maddalena_4.jpg',
        },
        {
            id: 5,
            imgSrc: '/images/Maddalena/Maddalena_5.jpg',
        },
        {
            id: 6,
            imgSrc: '/images/Maddalena/Maddalena_6.jpg',
        },
        {
            id: 7,
            imgSrc: '/images/Maddalena/Maddalena_7.jpg',
        },
        {
            id: 8,
            imgSrc: '/images/Maddalena/Maddalena_8.jpg',
        },
        {
            id: 9,
            imgSrc: '/images/Maddalena/Maddalena_9.jpg',
        },
        {
            id: 10,
            imgSrc: '/images/Maddalena/Maddalena_10.jpg',
        },
        {
            id: 11,
            imgSrc: '/images/Maddalena/Maddalena_11.jpg',
        },
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="Maddalena" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="Maddalena" style={{width: '100%'}} loading="lazy"/>
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Maddalena;
